import '../css/style.css';
console.log('Jumpex System Initialized');
